import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";

export function PresenterClock() {
	const [currentTime, setCurrentTime] = useState(new Date());

	useEffect(() => {
		let clockInterval = setInterval(() => setCurrentTime(new Date()), 1000);

		return function cleanup() {
			clearInterval(clockInterval);
		};
	}, [currentTime]);

	const deliverTime = () => {
		return currentTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
	};

	return (
		<Typography variant="h3" color="inherit">
			{deliverTime()}
		</Typography>
	);
}